// Dữ liệu mẫu board Mint-BLEdit (job SE260638050, B/L HNSGN260638050 · Draft v2) — chép từ script board, đúng dòng + thứ tự.
export const EDIT_JOB = { id: 'SE260638050', cus: 'PHAT NGUYEN', route: 'HO CHI MINH PORT → INCHEON PORT', vsl: 'SAWASDEE BALTIC 2616N · NAMSUNG', vol: '3×40HC', svc: 'FRT2652756' } as const;

export const EDIT_HBL = 'HNSGN260638050';
export const EDIT_VER = 2;

export const EDIT_PARTIES = {
  shipper: 'PHAT NGUYEN SUPPLY CO., LTD\nBINH DUONG PROVINCE, VIETNAM',
  cnee: 'GLOBAL CORP. CO.,LTD\nINCHEON, KOREA',
  notify: 'SAME AS CONSIGNEE',
  agent: 'SAE MYUNG SEA AND AIR CO.,INC\nSEOUL, KOREA',
} as const;
export type PartyKey = keyof typeof EDIT_PARTIES;

/** Consignee theo booking (so với B/L để báo lệch). */
export const EDIT_BOOK_CNEE = 'GLOBAL CORP. CO.,LTD\n#1203 SONGDO-DONG, YEONSU-GU, INCHEON, KOREA'; // token-ok: số nhà #1203, không phải mã màu
export const EDIT_SUGS: readonly (readonly [string, string])[] = [['GLOBAL CORP. CO.,LTD', 'GLOBAL CORP. CO.,LTD\nINCHEON, KOREA'], ['HANMI O AND F CO., LTD.', 'HANMI O AND F CO., LTD.\nGWANGYANG, KOREA']];

/** Tóm tắt hiện khi gập từng mục (SUM của board). */
export const EDIT_SUM = {
  route: 'SAWASDEE BALTIC 2616N · HO CHI MINH PORT → INCHEON PORT',
  cargo: '132 BAGS · 63,230 KGS · 3 cont · VGM Submitted',
  terms: 'HBL Surrender · MBL Seaway · Freight Prepaid',
  clause: 'DEM 7 / DET 7 ngày · in lên B/L',
  docs: '4 tệp',
} as const;

export type CheckKind = 'miss' | 'diff';
export interface EditCheck { k: string; src: string; kind: CheckKind; tip: string; fix?: string }
export const EDIT_CHECKS: readonly EditCheck[] = [
  { k: 'Consignee khác booking', src: 'Booking', kind: 'diff', tip: 'Booking: GLOBAL CORP. CO.,LTD · #1203 SONGDO-DONG, YEONSU-GU, INCHEON, KOREA', fix: 'Theo booking' }, // token-ok: số nhà #1203, không phải mã màu
  { k: 'Lệch SI · Consignee', src: 'SI', kind: 'diff', tip: 'SI: GLOBAL CORP. CO.,LTD · #1203 SONGDO-DONG, YEONSU-GU, INCHEON, KOREA | B/L: GLOBAL CORP. CO.,LTD · INCHEON, KOREA' }, // token-ok: số nhà #1203, không phải mã màu
  { k: 'Lệch SI · Mô tả hàng', src: 'SI', kind: 'diff', tip: 'SI: WOOD POWDER ( 80 MESH ) · HS CODE: 4401.40 | B/L: WOOD POWDER ( 80 MESH )' },
  { k: 'Lệch SI · Seal cont 3', src: 'SI', kind: 'diff', tip: 'SI: NS2589131 | B/L: NS2589113' },
];

export const EDIT_STEPS: readonly { k: string; d: string; done?: boolean; cur?: boolean }[] = [
  { k: 'Draft', d: `v${EDIT_VER} · 21/Oct`, cur: true },
  { k: 'Gửi khách', d: '—' },
  { k: 'Khách duyệt', d: '—' },
  { k: 'Phát hành', d: '—' },
];

export const EDIT_PEOPLE: readonly { u: string; name: string; role: string }[] = [
  { u: 'MAITTN', name: 'MAI', role: 'Chứng từ · CS' },
  { u: 'DAVID', name: 'DAVID', role: 'Sale' },
  { u: 'PHILIP', name: '[CSD-MGR] ghế trống → PHILIP', role: 'Duyệt revise' },
];

export const EDIT_TASKS: readonly { code: string; k: string; due: string; late?: boolean }[] = [
  { code: 'BLD', k: 'Gửi Draft HBL cho khách xác nhận', due: 'CloseDoc 22/Oct 11:00', late: true },
  { code: 'SNO', k: 'Gửi SNO cho đại lý SAE MYUNG', due: 'Sau MBL Released' },
  { code: 'FBL', k: 'Gửi Final B/L', due: 'ATD + 2h' },
];

export const EDIT_HIST: readonly { k: string; when: string; tone: 'info' | 'ai' | 'ok' | 'mute' }[] = [
  { k: 'MAI sửa Mô tả hàng, GW · lưu v2', when: '21/Oct 10:05', tone: 'info' },
  { k: 'Ask HANA đọc SI khách · chép 6 ô', when: '19/Oct 16:18', tone: 'ai' },
  { k: 'VGM Submitted · 3 cont', when: '19/Oct 15:40', tone: 'ok' },
  { k: 'Tạo B/L Surrender · cấp HBL HNSGN260638050', when: '19/Oct 15:02', tone: 'mute' },
  { k: 'Booking NAMSUNG confirmed', when: '17/Oct 08:29', tone: 'info' },
];

/** Giá trị mặc định các mục Tuyến & tàu · Hàng & container · Điều khoản & cước (V0 của board). */
export const EDIT_FIELDS = {
  hbl: 'HNSGN260638050', mbl: 'NSSLHCICC2601469', typeHbl: 'Surrender', typeMbl: 'Seaway', freight: 'Prepaid', cost: 'Prepaid', orig: '0', issue: 'HO CHI MINH PORT', blDate: '20/Oct/2026', ref: 'NSSLHCICC2601469', carrierBL: 'NAMSUNG',
  vessel: 'SAWASDEE BALTIC', voy: '2616N', sob: '20/Oct/2026', pre: '', por: 'HO CHI MINH PORT', pol: 'HO CHI MINH PORT', pod: 'INCHEON PORT', del: 'INCHEON PORT', dest: 'INCHEON, KOREA', term: 'FCL/FCL - CY/CY',
  pkgs: '132', unit: 'BAGS', gw: '63,230', gwu: 'KGS', cbm: '180', mark: 'N/M', desc: 'WOOD POWDER ( 80 MESH )',
} as const;
export type FieldKey = keyof typeof EDIT_FIELDS;

export interface FieldDef { k: string; key: FieldKey; span: 1 | 2 | 3; up?: boolean; area?: boolean; opts?: readonly string[]; req?: boolean }
export const EDIT_FIELD_DEFS: Record<'route' | 'cargo' | 'terms', readonly FieldDef[]> = {
  route: [
    { k: 'Tàu', key: 'vessel', span: 1, up: true, req: true }, { k: 'Chuyến', key: 'voy', span: 1, up: true, req: true }, { k: 'Ship on board', key: 'sob', span: 1 }, { k: 'Pre-carriage', key: 'pre', span: 1, up: true },
    { k: 'Place of receipt', key: 'por', span: 1, up: true }, { k: 'Port of loading', key: 'pol', span: 1, up: true, req: true }, { k: 'Port of discharge', key: 'pod', span: 1, up: true, req: true }, { k: 'Place of delivery', key: 'del', span: 1, up: true },
    { k: 'Final destination', key: 'dest', span: 2, up: true }, { k: 'Transport term', key: 'term', span: 2, opts: ['FCL/FCL - CY/CY', 'LCL/LCL - CFS/CFS'] },
  ],
  cargo: [
    { k: 'Số kiện', key: 'pkgs', span: 1, req: true }, { k: 'Đơn vị kiện', key: 'unit', span: 1, up: true }, { k: 'Gross weight', key: 'gw', span: 1 }, { k: 'Measurement (CBM)', key: 'cbm', span: 1 },
    { k: 'Shipping mark', key: 'mark', span: 1, area: true, up: true }, { k: 'Mô tả hàng', key: 'desc', span: 3, area: true, up: true, req: true },
  ],
  terms: [
    { k: 'Số HBL', key: 'hbl', span: 1, req: true }, { k: 'Loại HBL', key: 'typeHbl', span: 2, opts: ['Original', 'Surrender', 'Seaway'] }, { k: 'Số bản gốc', key: 'orig', span: 1 },
    { k: 'Số MBL', key: 'mbl', span: 1, req: true }, { k: 'Loại MBL', key: 'typeMbl', span: 2, opts: ['Original', 'Surrender', 'Seaway'] }, { k: 'Carrier on B/L', key: 'carrierBL', span: 1, up: true },
    { k: 'Freight', key: 'freight', span: 1, opts: ['Prepaid', 'Collect'] }, { k: 'Cost payment', key: 'cost', span: 1, opts: ['Prepaid', 'Collect'] }, { k: 'Nơi phát hành', key: 'issue', span: 1, up: true }, { k: 'Ngày phát hành', key: 'blDate', span: 1 },
    { k: 'Customer reference', key: 'ref', span: 2 },
  ],
};

/** Container & VGM (C0 của board Mint-BLEdit). VGM = GW hàng + tare vỏ. */
export interface EditCont { no: string; seal: string; type: string; pk: number; gw: number; cbm: number; tare: number }
export const EDIT_CONTS: readonly EditCont[] = [
  { no: 'DYLU5150530', seal: 'NS2590408', type: '40HC', pk: 44, gw: 20530, cbm: 60, tare: 3900 },
  { no: 'DYLU5101237', seal: 'NS2590445', type: '40HC', pk: 44, gw: 21470, cbm: 60, tare: 3900 },
  { no: 'TXGU8618143', seal: 'NS2589113', type: '40HC', pk: 44, gw: 21230, cbm: 60, tare: 3880 },
];
export const EDIT_VOL = 3;
export const EDIT_VGM = 'Submitted' as 'Submitted' | 'Pending';

/** Kiểm số container theo ISO 6346 (logic của board). */
export function isoCheck(no: string): { ok: boolean; k: string } {
  const s = String(no || '').toUpperCase().replace(/\s/g, '');
  if (!/^[A-Z]{4}\d{7}$/.test(s)) return { ok: false, k: 'Sai định dạng (4 chữ + 7 số)' };
  const map: Record<string, number> = {};
  let v = 10;
  for (let c = 65; c <= 90; c++) { if (v % 11 === 0) v++; map[String.fromCharCode(c)] = v; v++; }
  let sum = 0;
  for (let i = 0; i < 10; i++) sum += (i < 4 ? map[s[i]!]! : Number(s[i])) * 2 ** i;
  const cd = (sum % 11) % 10;
  return cd === Number(s[10]) ? { ok: true, k: 'Đúng số kiểm ISO 6346' } : { ok: false, k: `Sai số kiểm (phải là ${cd})` };
}

/** Phí & chi phí của B/L — luật tiền: chỉ tên + trạng thái, KHÔNG số tiền (money=hide). */
export const EDIT_FEES: readonly { side: 'Thu' | 'Chi'; k: string; st: string; wait?: boolean }[] = [
  { side: 'Thu', k: 'B/L FEE (DOC) · phí phát hành B/L', st: 'Đã vào debit' },
  { side: 'Thu', k: 'SURRENDER FEE', st: 'Dự kiến' },
  { side: 'Thu', k: 'SEAL × 3 Cont', st: 'Đã vào debit' },
  { side: 'Chi', k: 'DOH', st: 'Chờ HĐ', wait: true },
  { side: 'Chi', k: 'COURIER FEE · chuyển phát chứng từ', st: 'Chưa có' },
];

/** Free time DEM / DET (ft của board). */
export const EDIT_FT = { dem: '7', det: '7', dnd: '14', plug: '' } as const;
export const EDIT_TERM = 'FCL/FCL - CY/CY';

/** Tệp gắn B/L. */
export const EDIT_DOCS: readonly (readonly [string, string])[] = [
  ['SI khách · PHAT NGUYEN.pdf', 'từ mail 19/Oct'],
  ['Booking confirmation NAMSUNG.pdf', 'BK'],
  [`Draft HBL v${EDIT_VER}.pdf`, 'sinh từ B/L'],
  ['Draft MBL NSSLHCICC2601469.pdf', 'hãng gửi'],
];
